export default {
  clean: () => import("/opt/buildhome/repo/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)
}